import { combineReducers } from "@reduxjs/toolkit";

import lawyerReducer from "./lawyer_reducers";
import chamberReducer from "./chamber_reducers";

const rootReducer = combineReducers({
  lawyer: lawyerReducer,
  chamber: chamberReducer,
});

export default rootReducer;
